var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38614 6.62027V3.646L5.32227 6.62027H8.38614Z",
    fill: "#03a65b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4576 3.33301H9.45654V7.14691C9.45654 7.43153 9.20733 7.67346 8.91414 7.67346H5V20.1398C5 20.4244 5.24921 20.6663 5.54241 20.6663H18.4576C18.7508 20.6663 19 20.4244 19 20.1398V3.85955C19 3.57493 18.7508 3.33301 18.4576 3.33301ZM9.10471 8.95425H14.8806C15.1738 8.95425 15.423 9.19617 15.423 9.48079C15.423 9.76541 15.1738 10.0073 14.8806 10.0073H9.10471C8.81152 10.0073 8.5623 9.76541 8.5623 9.48079C8.5623 9.19617 8.81152 8.95425 9.10471 8.95425ZM9.10471 10.9181H14.8806C15.1738 10.9181 15.423 11.16 15.423 11.4447C15.423 11.7293 15.1738 11.9712 14.8806 11.9712H9.10471C8.81152 11.9712 8.5623 11.7293 8.5623 11.4447C8.5623 11.1458 8.81152 10.9181 9.10471 10.9181ZM9.10471 12.8678H14.8806C15.1738 12.8678 15.423 13.1097 15.423 13.3943C15.423 13.6789 15.1738 13.9209 14.8806 13.9209H9.10471C8.81152 13.9209 8.5623 13.6789 8.5623 13.3943C8.5623 13.1097 8.81152 12.8678 9.10471 12.8678ZM9.10471 14.8316H13.4586C13.7518 14.8316 14.001 15.0736 14.001 15.3582C14.001 15.6428 13.7518 15.8847 13.4586 15.8847H9.10471C8.81152 15.8847 8.5623 15.6428 8.5623 15.3582C8.5623 15.0593 8.81152 14.8316 9.10471 14.8316Z",
    fill: "#03a65b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.94341377.svg";
export { ForwardRef as ReactComponent };